import { ErrorMessage, Field, Form, Formik } from 'formik';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ManageAccountLeft, SubMenuAccountComponent } from '../common';
import countryList from 'react-select-country-list';
import { getUserProfile, postChangeProfile } from '../accountPage.api';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import useFullPageLoader from 'modules/commons/isn/useFullPageLoader';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as action from '../accountPage.action';

function PersonalDetailComponent(props) {
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const { t } = useTranslation();
  const authUserData = JSON.parse(localStorage.getItem('authUserData'));

  const [initialValues, setInitialValues] = useState({
    FullName: '',
    Gender: '',
    Nationality: '',
    email: '',
    PhoneNumber: '',
    CompanyName: '',
    Address: '',
  });

  useEffect(() => {
    getUserProfile().then(res => {
      if (res) {
        setInitialValues({
          FullName: res.fullName === null ? '' : res.fullName,
          Gender: res.gender === null ? '' : res.gender,
          Nationality: res.nationality === null ? '' : res.nationality,
          email: res.email === null ? '' : res.email,
          PhoneNumber: res.phoneNumber === null ? '' : res.phoneNumber,
          CompanyName: res.companyName === null ? '' : res.companyName,
          Address: res.address === null ? '' : res.address,
        });
      }
    });
  }, []);

  const submitForm = (values, { resetForm }) => {
    showLoader();
    let FormData = require('form-data');
    let data = new FormData();

    data.append('FullName', values.FullName.trim());
    data.append('PhoneNumber', values.PhoneNumber);
    data.append('CompanyName', values.CompanyName);
    data.append('Address', values.Address);
    data.append('Gender', values.Gender);
    data.append('Nationality', values.Nationality);

    postChangeProfile(data).then(res => {
      if (res.status === 'success') {
        onSuccess();
        const newAuthUserData = {
          ...authUserData,
          userInfo: {
            ...authUserData.userInfo,
            fullName: values.FullName,
            phoneNumber: values.PhoneNumber,
          },
        };

        localStorage.setItem('authUserData', JSON.stringify(newAuthUserData));
        resetForm(initialValues);

        props.fetchAccountInfo();
      } else {
        onError();
      }
      hideLoader();
    });
  };

  const options = useMemo(() => countryList().getData(), []);

  const validationSchema = Yup.object().shape({
    FullName: Yup.string().required(t('owner_register.full_name_is_required')),
    PhoneNumber: Yup.string()
      .min(7, t('owner_register.phone_number_min_max'))
      .max(15, t('owner_register.phone_number_min_max')),
  });

  const messageSuccess = (
    <>
      <div>{t('manage_account.label_successProfile')}</div>
    </>
  );

  const onSuccess = () => {
    toast.success(messageSuccess, { autoClose: 5000 });
    getUserProfile().then(res => {
      if (res) {
        setInitialValues({
          FullName: res.fullName === null ? '' : res.fullName,
          Gender: res.gender === null ? '' : res.gender,
          Nationality: res.nationality === null ? '' : res.nationality,
          email: res.email === null ? '' : res.email,
          PhoneNumber: res.phoneNumber === null ? '' : res.phoneNumber,
          CompanyName: res.companyName === null ? '' : res.companyName,
          Address: res.address === null ? '' : res.address,
        });
      }
    });
  };
  const onError = err => toast.error(err, { autoClose: 5000, position: 'bottom-center' });

  return (
    <>
      <SubMenuAccountComponent />
      <div id="manageAccount" className="container">
        <div className="row mx-0 d-block d-md-flex">
          {/* Left */}
          <ManageAccountLeft />

          {/* Right */}
          <div className="col-12 col-md-8 pr-0 pl-0 pl-md-3">
            <div className="personal-detail__right">
              <div className="personal-detail__right-title">{t('manageAccount.label_personalDeail')}</div>

              <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={submitForm}
              >
                {formik => {
                  const { errors, touched, setFieldValue } = formik;

                  return (
                    <Form>
                      <div className="form-group">
                        <label className="form-group__label">
                          {t('manageAccount.label_fullName')} <span className="required-star">*</span>
                        </label>
                        <Field
                          type="text"
                          name="FullName"
                          className={errors.FullName && touched.FullName ? 'form-control input-error' : 'form-control'}
                          maxLength={25}
                        />
                        <ErrorMessage name="FullName" component="span" className="error" />
                      </div>

                      <div className="form-group">
                        <div className="row">
                          <div className="col-4">
                            <label>{t('manageAccount.label_gender')}</label>
                            <Field name="Gender" as="select" className="form-control select-control">
                              <option value="">{t('manageAccount.label_selectOne')}</option>
                              <option value="male">{t('manageAccount.label_male')}</option>
                              <option value="female">{t('manageAccount.label_feMale')}</option>
                            </Field>
                          </div>

                          <div className="col-8">
                            <label className="form-group__label">{t('manageAccount.label_nationality')}</label>
                            <Field name="Nationality" as="select" className="form-control select-control">
                              <option value="">{t('manageAccount.label_selectOne')}</option>
                              {options && options.length
                                ? options.map((item, index) => (
                                    <option value={item.value} key={index}>
                                      {item.label}
                                    </option>
                                  ))
                                : []}
                            </Field>
                          </div>
                        </div>
                      </div>

                      {initialValues.email !== null ? (
                        <div className="form-group">
                          <label className="form-group__label">{t('payment.label_email')}</label>
                          <Field
                            type="text"
                            name="email"
                            className={
                              errors.email && touched.email
                                ? 'form-control input-error personal-detail__right-email'
                                : 'form-control personal-detail__right-email'
                            }
                            maxLength={191}
                            readOnly
                            disabled
                          />
                          <ErrorMessage name="email" component="span" className="error" />
                        </div>
                      ) : (
                        ''
                      )}

                      <div className="form-group">
                        <label className="form-group__label">{t('manageAccount.label_phone')}</label>
                        <Field
                          type="text"
                          name="PhoneNumber"
                          className={
                            errors.PhoneNumber && touched.PhoneNumber ? 'form-control input-error' : 'form-control'
                          }
                          onChange={event =>
                            setFieldValue(
                              event.target.name,
                              event.target.value
                                .replace(/[^\d/+-]/g, '')
                                .replace(/^([+0-9]{3})([0-9]{3})([0-9]{4})$/, '$1$2$3'),
                            )
                          }
                        />
                        <ErrorMessage name="PhoneNumber" component="span" className="error" />
                      </div>

                      <div className="form-group">
                        <label>{t('manageAccount.label_company')}</label>
                        <Field
                          type="text"
                          className={
                            errors.CompanyName && touched.CompanyName ? 'form-control input-error' : 'form-control'
                          }
                          name="CompanyName"
                          maxLength={191}
                        />
                        <ErrorMessage name="CompanyName" component="span" className="error" />
                      </div>

                      <div className="form-group">
                        <label>{t('manageAccount.label_address')}</label>
                        <Field
                          type="text"
                          className={errors.Address && touched.Address ? 'form-control input-error' : 'form-control'}
                          name="Address"
                          maxLength={191}
                        />
                        <ErrorMessage name="Address" component="span" className="error" />
                      </div>

                      <div className="d-flex justify-content-end button-confirm-page pt-3">
                        <button
                          type="submit"
                          // disabled={!(isShowSubmit === true && isTransferred === true)}
                          className="personal-detail__right-button_save"
                        >
                          {t('manageAccount.label_save')}
                        </button>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </div>
          </div>
        </div>
      </div>
      {loader}
    </>
  );
}

const mapStateToProps = state => ({
  ...state,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchAccountInfo: action.fetchAccountInfo,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(PersonalDetailComponent);
